import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import { useTranslation } from "react-i18next";

export function ErrorMessage ( {showDialogError, errorDialogTitle, errorType, handleClose} ) {

    const { t, i18n } = useTranslation();

    return (
        <>
            <Dialog
                open={showDialogError}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle>
                    {t(errorDialogTitle)}
                </DialogTitle>
                <DialogContent>
                    {t(errorType)}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>{t('general.aceptar')}</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
